<template>
    <div class="blockname-wrapper" @click="handleClick">
      <span>{{ blockName }}</span>
    </div>
  </template>
  
  <script>   
  
    export default {
      components: { },
      props: {
        blockName: null,
        url: null,
      },
      data() {
          return {
  
          };
        },
      methods: {
        handleClick(){
          if(this.url != null){
            this.$router.push({
              path: this.url,
            });
          }
        }
      },
      created() {},
      mounted() {}
    };
  </script>
  
  <style scoped>
    .blockname-wrapper{  
        flex: 0 0 80px;
        height: 80px;  
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 16px;
        background: #014289;
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
        letter-spacing: 0em;
        color: #FFFFFF;
        cursor: pointer;
    }
    .blockname-wrapper span{
        text-align: center;
    }

    @media screen and (max-width: 1000px) {
      .blockname-wrapper{
        height: auto !important;
        flex: 0 0 auto !important;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        padding: 4px 24px;
        align-self: start;        
      }
    }

  </style>
  


// WEBPACK FOOTER //
// src/components/blocks/memoryblock/blockname.vue